import BaseService from './base.service'

class InscricaoAutomatizada extends BaseService {
  constructor() {
    super({ resource: 'inscricaoautomatizada' })
  }
}

export default new InscricaoAutomatizada()
